// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '8d33fda4-705f-4ce2-b5a7-2b423caccb8f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Offer_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'bbef22c7-6ef9-4e66-841e-490567e3e46d',
      type: 'Sprite',
      runtimeType: null,
      name: 'icon',
      className: '',
      x: -264,
      y: 28,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_1',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '48ac57fb-39a7-4554-ad38-c59dc7755b1f',
      type: 'Container',
      runtimeType: null,
      name: 'buyButton',
      className: '',
      x: 220,
      y: -16,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8b14a2bc-5b2d-477b-8d9b-fbf6e57d7a76',
      type: 'Text',
      runtimeType: null,
      name: 'coinRewardText',
      className: '',
      x: -164,
      y: -18,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8F2C2B',
        stroke: '#ffffff',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 1,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fe1699d0-66f6-4dd8-a514-eb0f8587f969',
      type: 'Layout',
      runtimeType: null,
      name: 'nineSliceButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '48ac57fb-39a7-4554-ad38-c59dc7755b1f',
      data: {
        color: 'green'
      },
      stateByName: {}
    },
    {
      id: '04f19399-c136-495e-921f-4cbe6412ef74',
      type: 'Text',
      runtimeType: null,
      name: 'priceLabelText',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$5,49',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#01632D',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '48ac57fb-39a7-4554-ad38-c59dc7755b1f',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ShopCoinOfferLayout {
  static raw = raw;
  root: Container;
  icon: Sprite;
  buyButton: Container;
  coinRewardText: Text;
  nineSliceButton: ButtonLargeLayout & { data: typeof raw['list'][5]['data'] };
  priceLabelText: Text;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      icon: typeof raw['list'][2];
      buyButton: typeof raw['list'][3];
      coinRewardText: typeof raw['list'][4];
      nineSliceButton: typeof raw['list'][5];
      priceLabelText: typeof raw['list'][6];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
